require("./dialog/dialog-form-factory")
require("./dialog/dialog-form")

require("./sidebar/sidebar-panel")
require("./sidebar/sidebar-manager")
require("./sidebar/sidebar-tooltip.component")
require("./sidebar/sidebar-tooltip.component-click")

require("./sidebar-form/sidebar-form")
